import { render, staticRenderFns } from "./liftRightBatch.vue?vue&type=template&id=9b603c60&"
import script from "./liftRightBatch.vue?vue&type=script&lang=js&"
export * from "./liftRightBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports